module.exports = __webpack_public_path__ + "static/media/correct-note.ff383552.png";